import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import useStore from "../../../../../../context/useStore";
import tools from "../../../../../../helpers/tools";
import { getLinkedLeads } from "../../../../../../services/leadService";
import ProduitLead from "../../../../../common/CarteLead/ProduitLead";
import Loader from "../../../../../common/Loader";
import { LeadContext } from "../../LeadContext";
import { produitDuLead } from "../profilLead";
import useLeadItem from "../useLeadItem";

// Demandes liées d'un lead entreprise : les autres demandes de la même
// société (même devis de départ), avec leur produit, leur statut et leur date.
// Une demande présente dans la liste s'ouvre dans ce panneau ; sinon elle
// s'ouvre dans la liste des leads, dans un nouvel onglet.
const DemandesLiees = () => {
  const { lead } = useLeadItem();
  const { panneau } = useContext(LeadContext);
  const [state] = useStore();
  const { LEAD_STATUS = [] } = state.constants.items;
  const [liees, setLiees] = useState(null);
  const [erreur, setErreur] = useState(false);

  useEffect(() => {
    let actif = true;
    if (!lead.quotationId) {
      setLiees([]);
      return undefined;
    }
    getLinkedLeads(lead.quotationId)
      .then((data) => actif && setLiees((Array.isArray(data) ? data : []).filter((l) => l.id !== lead.id)))
      .catch(() => actif && setErreur(true));
    return () => {
      actif = false;
    };
  }, [lead.quotationId, lead.id]);

  if (erreur) return <p className="la-aucun">Les demandes liées n'ont pas pu être chargées. Réessayez plus tard.</p>;
  if (!liees) return <Loader />;
  if (!liees.length) {
    return (
      <div className="la-vide">
        <i className="fa fa-link" aria-hidden="true" />
        Aucune autre demande pour cette société.
      </div>
    );
  }

  return (
    <>
      <ol className="la-liees">
        {liees.map((l) => {
          const statut = LEAD_STATUS.find((s) => s.id === l.status);
          const produit = produitDuLead(l, "PRO", state.constants.items);
          const dansLaListe = panneau.ids.includes(l.id);
          return (
            <li key={l.id} className={`la-liees__item la-ton-${(statut && statut.color) || "primary"}`}>
              <ProduitLead {...produit} petit />
              <div className="la-liees__corps">
                <b>{produit.nom}</b>
                <span className="la-liees__meta">
                  {statut && (
                    <>
                      <i className={`fa fa-${statut.icon}`} aria-hidden="true" />
                      {statut.name} ·{" "}
                    </>
                  )}
                  créée le {tools.formatDate(l.createdAt, "dd/MM/yyyy")}
                  {l.isFinalized && " · finalisée"}
                </span>
              </div>
              {dansLaListe ? (
                <button type="button" className="la-bouton-lien" onClick={() => panneau.ouvrir(l.id, "infos")}>
                  Ouvrir
                </button>
              ) : (
                <Link className="la-bouton-lien" to={`/leads?leadId=${l.id}`} target="_blank" title="Ouvrir dans la liste des leads, dans un nouvel onglet">
                  Voir dans la liste
                </Link>
              )}
            </li>
          );
        })}
      </ol>
      <p className="la-aide">Les demandes liées sont les autres demandes de la même société. Celles de cette page s'ouvrent ici.</p>
    </>
  );
};

export default DemandesLiees;
